/* =========================================================
   Affiche MUSCULATION « La Progression » — la courbe d'un mouvement.
   API : SNMuscuProgression.render(data, opts) -> string SVG
     data : { lift, name, period, title, unit, duration, footer,
              p1..p8 (libellé du jalon), v1..v8 (charge kg) }
     opts : { palette }
   Courbe, échelle, jalons, écart et pourcentage de progression sont
   CALCULÉS automatiquement depuis les points saisis.
   Auto-suffisant (aucune carte) → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 66;

  const PALETTES = {
    craie: { label: 'Craie', bg: '#F7F4ED', ink: '#0B2D5B', muted: '#8B94A3', accent: '#FF6B2C', line: '#E3DDD0', fillOp: '0.10' },
    nuit:  { label: 'Nuit',  bg: '#0B2D5B', ink: '#F7F4ED', muted: '#93A1B8', accent: '#FF6B2C', line: '#1E4272', fillOp: '0.18' },
    fonte: { label: 'Fonte', bg: '#15191F', ink: '#F5F2EA', muted: '#8A93A0', accent: '#FF6B2C', line: '#272D36', fillOp: '0.18' },
    acier: { label: 'Acier', bg: '#E7E9EC', ink: '#14243B', muted: '#77808F', accent: '#FF6B2C', line: '#D3D7DD', fillOp: '0.12' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fmt = n => (Math.round(n * 100) / 100).toFixed(2).replace(/\.?0+$/, '').replace('.', ',');
  const fitSize = (text, maxW, maxSize, cwf, ls, minSize) => {
    const n = String(text).length || 1; minSize = minSize || 12;
    for (let s = maxSize; s > minSize; s -= 1) if (n * (cwf * s + ls) <= maxW) return s;
    return minSize;
  };

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const cx = PW / 2;
    const unit = String(data.unit || 'KG').trim().toUpperCase();

    /* --- points saisis --- */
    const pts = [];
    for (let i = 1; i <= 8; i++) {
      const v = num(data['v' + i]);
      if (v == null) continue;
      pts.push({ lab: up(data['p' + i]).trim(), v });
    }

    const title = up(data.title) || 'LA PROGRESSION';
    const titleLs = title.length > 18 ? 2 : 2.5;
    // max 70 + baseline 178 : la boîte d'ascente Oswald (≈1,2×) reste à ≥10 px
    // sous le sur-titre (baseline 76) — accents É compris.
    const titleSize = fitSize(title, 700, 70, 0.54, titleLs, 34);
    const sub = [up(data.name), up(data.period)].filter(Boolean).join(' · ');

    /* --- zone de tracé --- */
    const X0 = 108, X1 = PW - MX, Y0 = 800, Y1 = 408;
    let chart = '';
    let statVals = ['—', '—', '—', up(data.duration) || '—'];

    if (pts.length >= 2) {
      const vals = pts.map(o => o.v);
      const vMin = Math.min.apply(null, vals), vMax = Math.max.apply(null, vals);
      const span = Math.max(vMax - vMin, 1);
      const lo = vMin - span * 0.28, hi = vMax + span * 0.20;
      const xx = i => X0 + (i / (pts.length - 1)) * (X1 - X0);
      const yy = v => Y0 - ((v - lo) / (hi - lo)) * (Y0 - Y1);

      /* graduations : 4 paliers ronds dans l'intervalle */
      const rawStep = (vMax - vMin) / 3 || 1;
      const mag = Math.pow(10, Math.floor(Math.log(rawStep) / Math.LN10));
      const step = [1, 2, 2.5, 5, 10].map(m => m * mag).find(s => s >= rawStep) || mag * 10;
      const gStart = Math.ceil(vMin / step) * step;
      for (let g = gStart; g <= vMax + 0.001; g += step) {
        const y = yy(g);
        chart += `<line x1="${X0 - 12}" y1="${y.toFixed(1)}" x2="${X1}" y2="${y.toFixed(1)}" stroke="${p.line}" stroke-width="1.5"/>`
          + `<text x="${X0 - 24}" y="${(y + 6).toFixed(1)}" text-anchor="end" font-size="16" font-weight="600" fill="${p.muted}">${fmt(g)}</text>`;
      }

      const coords = pts.map((o, i) => `${xx(i).toFixed(1)},${yy(o.v).toFixed(1)}`);
      chart += `<path d="M ${coords[0]} L ${coords.slice(1).join(' L ')} L ${X1},${Y0} L ${X0},${Y0} Z" fill="${p.accent}" opacity="${p.fillOp}"/>`;
      chart += `<path d="M ${coords[0]} L ${coords.slice(1).join(' L ')}" fill="none" stroke="${p.accent}" stroke-width="5" stroke-linejoin="round" stroke-linecap="round"/>`;
      pts.forEach((o, i) => { chart += `<circle cx="${xx(i).toFixed(1)}" cy="${yy(o.v).toFixed(1)}" r="5.5" fill="${p.ink}"/>`; });

      /* jalons : départ (sous le point) + record (au-dessus). Ancrage par
         POSITION (pas par index) + clamp pour ne jamais déborder du canevas. */
      const first = pts[0], last = pts[pts.length - 1];
      const iMax = vals.indexOf(vMax);
      const recLabel = `RECORD · ${fmt(vMax)} ${esc(unit)}`;
      const recW = recLabel.length * (0.56 * 34);
      const rx = xx(iMax), ry = yy(vMax);
      let recAnchor = 'middle', recX = rx;
      if (rx - recW / 2 < MX) { recAnchor = 'start'; recX = MX; }
      else if (rx + recW / 2 > PW - MX) { recAnchor = 'end'; recX = PW - MX; }
      // "DÉPART" seulement si le premier point n'est pas déjà le record (sinon superposition)
      if (iMax !== 0) chart += `<text x="${(xx(0) + 4).toFixed(1)}" y="${(yy(first.v) + 36).toFixed(1)}" font-size="18" font-weight="700" fill="${p.ink}" letter-spacing="1">DÉPART · ${fmt(first.v)} ${esc(unit)}</text>`;
      chart += `<circle cx="${rx.toFixed(1)}" cy="${ry.toFixed(1)}" r="11" fill="${p.accent}"/><circle cx="${rx.toFixed(1)}" cy="${ry.toFixed(1)}" r="4.5" fill="${p.bg}"/>`;
      chart += `<text x="${recX.toFixed(1)}" y="${(ry - 26).toFixed(1)}" text-anchor="${recAnchor}" font-family="Oswald" font-size="34" font-weight="700" fill="${p.ink}" letter-spacing="1">${recLabel}</text>`;

      /* libellés d'abscisse : premier, milieu, dernier (si renseignés) */
      const idx = pts.length > 2 ? [0, Math.floor((pts.length - 1) / 2), pts.length - 1] : [0, pts.length - 1];
      idx.forEach((i, k) => {
        if (!pts[i].lab) return;
        const anchor = k === 0 ? 'start' : (k === idx.length - 1 ? 'end' : 'middle');
        const x = k === 0 ? X0 : (k === idx.length - 1 ? X1 : xx(i));
        chart += `<text x="${x.toFixed(1)}" y="${Y0 + 38}" text-anchor="${anchor}" font-size="16" font-weight="600" fill="${p.muted}" letter-spacing="2">${esc(pts[i].lab)}</text>`;
      });

      const delta = vMax - first.v;
      const pct = first.v ? Math.round((delta / first.v) * 100) : 0;
      statVals = [`${fmt(first.v)} ${unit}`, `${fmt(vMax)} ${unit}`, `${delta >= 0 ? '+' : ''}${pct} %`, up(data.duration) || `${pts.length} JALONS`];
    }

    /* --- héros --- */
    let heroVal = '—', heroSub = up(data.footer) || 'VOTRE COURBE COMMENCE ICI';
    if (pts.length >= 2) {
      const vals = pts.map(o => o.v);
      const d = Math.max.apply(null, vals) - pts[0].v;
      heroVal = `${d >= 0 ? '+' : ''}${fmt(d)}`;
      heroSub = up(data.footer) || (data.duration ? `EN ${up(data.duration)}, SANS RIEN LÂCHER` : 'DE PROGRÈS, SÉANCE APRÈS SÉANCE');
    }

    /* --- bandeau de stats --- */
    const labels = ['DÉPART', 'RECORD', 'PROGRESSION', 'DURÉE'];
    const bx0 = 54, bw = (PW - 108) / 4;
    let stats = `<line x1="${bx0}" y1="878" x2="${PW - bx0}" y2="878" stroke="${p.line}" stroke-width="1.5"/>`;
    labels.forEach((lab, i) => {
      const c = bx0 + bw * i + bw / 2;
      if (i) stats += `<line x1="${bx0 + bw * i}" y1="918" x2="${bx0 + bw * i}" y2="1000" stroke="${p.line}" stroke-width="1.5"/>`;
      const val = statVals[i];
      const vs = String(val).length > 8 ? 26 : String(val).length > 6 ? 32 : 40;
      stats += `<text x="${c}" y="944" font-size="14" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="2.5">${esc(lab)}</text>`
        + `<text x="${c}" y="994" font-family="Oswald" font-size="${vs}" font-weight="700" fill="${p.ink}" text-anchor="middle">${esc(val)}</text>`;
    });

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<text x="${cx}" y="76" font-size="20" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="5">${esc(up(data.lift) || 'VOTRE MOUVEMENT')}</text>
<text x="${cx}" y="178" font-family="Oswald" font-size="${titleSize}" font-weight="700" fill="${p.ink}" text-anchor="middle" letter-spacing="2">${esc(title)}</text>
${sub ? `<text x="${cx}" y="210" font-size="17" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="3">${esc(sub)}</text>` : ''}
<text x="${MX}" y="300" font-family="Oswald" font-weight="700" fill="${p.accent}"><tspan font-size="76">${esc(heroVal)}</tspan><tspan font-size="30" dx="6">${esc(unit)}</tspan></text>
<text x="${MX}" y="330" font-size="15" font-weight="600" fill="${p.muted}" letter-spacing="2.5">${esc(heroSub)}</text>
${chart}
${stats}
</svg>`;
  }

  window.SNMuscuProgression = { render, PALETTES };
})();
